import React from 'react';

import { AbTestingProvider, useAbTestingSdk } from '@sravni/react-utils';
import type { ISravniTMOptions } from '@sravni/utils/lib/analytics';

import { SpecialOffers } from 'src/components/SpecialOffers';

import NoSSR from '../../components/NoSSR';
import type { ISpecialOffersContext } from '../../contexts/OffersPageQueryContext';
import { SpecialOffersContext } from '../../contexts/OffersPageQueryContext';
import { convertOffersPageQuery } from '../../helpers/convertQuery';
import { useUser } from '../../store/hooks/users';
import type { TOffersPageQuery } from '../../types/query';
import { isServer } from '../../utils/isServer';

interface IProps {
  convertedQuery: ISpecialOffersContext;
  abTestingInfo: IAbTestingInfo;
}

const OffersPage = (props: IProps) => {
  const { abTestingInfo, convertedQuery } = props;
  const abTestingSdk = useAbTestingSdk();
  const abTestingStatistics = abTestingSdk ? abTestingSdk.getAnalyticsStatistics() : undefined;
  const user = useUser();

  // @ts-ignore
  const analyticsOptions: ISravniTMOptions = {
    ...(abTestingStatistics ? { abTestingStatistics } : {}),
    googleTmId: 'GTM-PMDFG9',
    ...(user && { userId: user.sub }),
  };

  return (
    <NoSSR>
      {/* <Head>*/}
      {/*  <script dangerouslySetInnerHTML={{ __html: initSravniTM(analyticsOptions) }} />*/}
      {/* </Head>*/}
      <AbTestingProvider value={abTestingInfo}>
        <SpecialOffersContext.Provider value={convertedQuery}>
          <SpecialOffers />
        </SpecialOffersContext.Provider>
      </AbTestingProvider>
    </NoSSR>
  );
};

OffersPage.getInitialProps = (ctx: App.ReduxNextPageContext<TOffersPageQuery>): IProps => {
  const { query } = ctx;

  const convertedQuery = convertOffersPageQuery(query);
  const abTestingInfo = isServer && ctx.req.__AB_TESTING__ ? ctx.req.__AB_TESTING__ : undefined;

  return {
    convertedQuery,
    abTestingInfo,
  };
};

export default OffersPage;
